import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Params } from '@angular/router';

export interface IRoutePart {
  title: string;
  breadcrumb: string;
  params?: Params;
  url: string;
  urlSegments: any[];
}

@Injectable({ providedIn: 'root' })
export class RoutePartsService {
  generateRouteParts(snapshot?: ActivatedRouteSnapshot): IRoutePart[] {
    if (!snapshot) return [];
    const parts: IRoutePart[] = [];
    this._extractParts(snapshot, '', parts);
    return parts;
  }

  private _extractParts(snapshot: ActivatedRouteSnapshot, parentUrl: string, parts: IRoutePart[]): void {
    if (!snapshot) return;

    const routeData = snapshot.data;
    const urlSegments = snapshot.url || [];

    const currentUrl = urlSegments.map((s) => s.path).join('/');
    const fullUrl = parentUrl + (currentUrl ? `/${currentUrl}` : '');

    if (routeData?.title) {
      parts.push({
        title: routeData.title,
        breadcrumb: routeData.breadcrumb || routeData.title,
        params: snapshot.params,
        url: fullUrl,
        urlSegments,
      });
    }

    if (snapshot.firstChild) {
      this._extractParts(snapshot.firstChild, fullUrl, parts);
    }
  }
}
